module.exports = __webpack_public_path__ + "img/banner.cfdc7f1f.png";